var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoIaqsIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.2782 19.4173",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29991 16.2175V12.6942C7.37243 12.7078 6.44791 12.8023 5.53689 12.9768C6.19475 14.7711 7.18669 16.0069 8.29991 16.2175Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29987 4.20295C7.30106 4.18832 6.30555 4.08454 5.32519 3.89284C4.95968 5.15356 4.76346 6.4573 4.7417 7.76976H8.29987V4.20295Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29987 8.44815H4.7417C4.76261 9.76128 4.95806 11.0658 5.3229 12.3274C6.30296 12.1334 7.29861 12.0288 8.29758 12.015L8.29987 8.44815Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29989 0C7.18553 0.211697 6.19473 1.4487 5.53458 3.24526C6.4467 3.41705 7.37184 3.51047 8.29989 3.52447V0Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64545 12.4853C4.27585 11.1708 4.08045 9.81351 4.06424 8.44815H0.702858C0.84244 9.18051 1.00834 9.96894 1.2097 10.8157C1.33672 11.3534 1.50895 11.8794 1.72455 12.388C1.94663 12.7478 2.19682 13.0895 2.47279 13.4099C2.99794 13.038 3.73932 12.7233 4.64545 12.4853Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85246 13.1327C4.06074 13.3387 3.40173 13.6076 2.93608 13.9131C3.93784 14.8992 5.17791 15.6088 6.53544 15.9729C5.85127 15.3115 5.27921 14.3342 4.85246 13.1327Z",
    fill: "#4A4A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6347 3.73731C13.0026 5.05053 13.1976 6.40616 13.2148 7.76985H16.7066C16.7226 7.67602 16.7386 7.58333 16.7547 7.49179C16.625 5.77127 15.9501 4.13697 14.828 2.82644C14.288 3.19262 13.5409 3.50272 12.6347 3.73731Z",
    fill: "#4A4A4A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53787 0.242365C5.17178 0.609345 3.92467 1.32549 2.91906 2.32043C3.52059 2.67304 4.17214 2.93232 4.85145 3.08941C5.27935 1.88559 5.8514 0.906064 6.53787 0.242365Z",
    fill: "#4A4A4A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.523393 7.49175C0.539411 7.58215 0.555428 7.67598 0.57259 7.76981H4.06326C4.08042 6.40612 4.27542 5.05049 4.64332 3.73727C3.73719 3.50841 2.99009 3.19258 2.45007 2.82182C1.32689 4.13346 0.651873 5.76958 0.523393 7.49175Z",
    fill: "#4A4A4A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0523 5.46357C17.3314 3.17496 17.2731 1.95512 17.2731 1.95512C17.2731 1.95512 16.3773 1.68392 13.874 1.01793C15.3748 2.12833 16.487 3.68407 17.0523 5.46357Z",
    fill: "#4A4A4A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4278 3.08941C13.1068 2.93234 13.7579 2.67306 14.3591 2.32043C13.3541 1.32583 12.1078 0.609709 10.7425 0.242365C11.4233 0.906064 12.0011 1.88559 12.4278 3.08941Z",
    fill: "#4A4A4A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5819 8.44815H13.2148C13.1976 9.81351 13.0019 11.1708 12.6324 12.4853C13.5385 12.7233 14.2799 13.038 14.8062 13.4099C15.0822 13.0895 15.3324 12.7478 15.5545 12.388C15.7701 11.8794 15.9423 11.3534 16.0693 10.8157C16.2752 9.96894 16.4411 9.18051 16.5819 8.44815Z",
    fill: "#4A4A4A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4255 13.1327C11.9999 14.3342 11.4221 15.3069 10.7425 15.974C12.1001 15.6099 13.3401 14.9003 14.3419 13.9143C13.8763 13.6076 13.2172 13.3387 12.4255 13.1327Z",
    fill: "#4A4A4A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06311 16.9113C6.43013 16.806 4.85953 16.2441 3.53016 15.2898C5.17424 17.2282 7.24393 18.5316 8.63974 19.4173C10.0321 18.5327 12.0995 17.2305 13.7436 15.2978C12.0931 16.4754 10.0861 17.0454 8.06311 16.9113Z",
    fill: "#4A4A4A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3962 1.02024C0.903195 1.68509 0.00507089 1.95514 0.00507089 1.95514C0.00507089 1.95514 -0.0532785 3.17383 0.225884 5.46474C0.78801 3.68613 1.89759 2.1306 3.3962 1.02024Z",
    fill: "#4A4A4A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97816 12.015C9.97713 12.0289 10.9728 12.1334 11.9528 12.3274C12.3177 11.0658 12.5131 9.76128 12.534 8.44815H8.97587L8.97816 12.015Z",
    fill: "#4A4A4A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9563 3.89054C10.976 4.0824 9.98045 4.18581 8.98165 4.1995V7.76974H12.5398C12.5183 6.45651 12.322 5.15199 11.9563 3.89054Z",
    fill: "#4A4A4A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97818 0V3.52447C9.90585 3.51051 10.8306 3.4171 11.7423 3.24526C11.0891 1.4487 10.0925 0.211697 8.97818 0Z",
    fill: "#4A4A4A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7412 12.9768C10.8302 12.8024 9.90565 12.7078 8.97818 12.6942V16.2175C10.0914 16.0069 11.0879 14.7699 11.7412 12.9768Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoIaqsIndicator);
export default __webpack_public_path__ + "static/media/GoIaqsIndicator.26782ce4ec5475045d2fa4fd26b62aff.svg";
export { ForwardRef as ReactComponent };